<script setup lang="ts"></script>

<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.79289 5.29289C9.18342 4.90237 9.81658 4.90237 10.2071 5.29289L15.5 10.5858C16.281 11.3668 16.281 12.6332 15.5 13.4142L10.2071 18.7071C9.81658 19.0976 9.18342 19.0976 8.79289 18.7071C8.40237 18.3166 8.40237 17.6834 8.79289 17.2929L14.0858 12L8.79289 6.70711C8.40237 6.31658 8.40237 5.68342 8.79289 5.29289Z"
      fill="currentColor"
    />
  </svg>
</template>
